import { Text } from "../../../../../text";
import { PageSizeSelector } from "./page-size-selector";
import { PageSizeProps } from "./types";
import styles from "./styles.module.scss";

export const PageSize = ({
  currentPage,
  pageSize = 20,
  totalElements,
  isLastPage,
  availablePageSizes,
  dataTestId,
  onPageSizeChange,
}: PageSizeProps) => (
  <div className={styles["page-size"]} data-test-id={dataTestId}>
    <PageSizeSelector
      pageSize={pageSize}
      availablePageSizes={availablePageSizes}
      dataTestId={`${dataTestId}-selector`}
      onPageSizeChange={onPageSizeChange}
    />
    <div
      className={styles["page-size-info"]}
      data-test-id={`${dataTestId}-info`}
    >
      <Text>
        {currentPage * pageSize - pageSize + 1}-
        {isLastPage ? totalElements : currentPage * pageSize} записей из{" "}
        {totalElements}
      </Text>
    </div>
  </div>
);
